<section class="ct" id="get-in-touch" #root aria-labelledby="ct-title">
  <!-- ============================================================
       BACKGROUND — blobs, dots, curves, paper plane
       ============================================================ -->
  <div class="ct__bg" aria-hidden="true">
    <span class="ct__blob ct__blob--pink"></span>
    <span class="ct__blob ct__blob--violet"></span>

    <span class="ct__dotfield ct__dotfield--l"></span>
    <span class="ct__dotfield ct__dotfield--r"></span>

    <span class="ct__motes">
      <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
    </span>

    <!-- the plane traces this curve, then loops -->
    <svg class="ct__flight" viewBox="0 0 420 320" fill="none">
      <path
        id="ctPath"
        class="ct__flight-path"
        d="M18 42C120 28 214 78 246 150c26 58-14 118-70 118-44 0-70-38-52-74 22-44 96-40 148-14 40 20 66 52 82 88"
        stroke="url(#ctGrad)"
        stroke-width="1.6"
        stroke-dasharray="5 8"
      />
      <defs>
        <linearGradient id="ctGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#ff4fa3" stop-opacity=".5" />
          <stop offset="100%" stop-color="#a855f7" stop-opacity="0" />
        </linearGradient>
      </defs>

      <g class="ct__plane">
        <path
          d="M0-11 15 8-1 2-15 9z"
          fill="url(#ctPlane)"
          stroke="#ff4fa3"
          stroke-width="1"
          stroke-linejoin="round"
        />
        <defs>
          <linearGradient id="ctPlane" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#ffd7ea" />
            <stop offset="100%" stop-color="#c9a7ff" />
          </linearGradient>
        </defs>
      </g>
    </svg>
  </div>

  <div class="container ct__inner">
    <!-- ============================================================
         HEADER
         ============================================================ -->
    <header class="ct__head" #head>
      <span class="ct__badge">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M21.5 2.5 11 13" />
          <path d="M21.5 2.5 15 21l-4-8-8-4z" />
        </svg>
        LET'S CONNECT
      </span>

      <h2 class="ct__title" id="ct-title">
        Get In <span class="ct__title-grad">Touch</span>
      </h2>

      <span class="ct__divider" aria-hidden="true"><i></i><em></em><i></i></span>

      <p class="ct__lede">
        Ready to discuss your project?<br />
        Let's build something amazing together.
      </p>
    </header>

    <!-- ============================================================
         CONTACT CARDS
         ============================================================ -->
    <ul class="ct__grid" #grid>
      <li class="ct__card">
        <span class="ct__ico ct__ico--pink" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 21V6.5L12 3l8 3.5V21" />
            <path d="M4 21h16M9 21v-5h6v5" />
            <path d="M8 9h.01M12 9h.01M16 9h.01M8 12.5h.01M12 12.5h.01M16 12.5h.01" />
          </svg>
        </span>

        <h3 class="ct__name">Our Address</h3>
        <span class="ct__rule" aria-hidden="true"></span>

        <address class="ct__body">
          2nd Floor Emerald Plaza, Opposite Vinayak Netralaya, Near Agrasen
          Chowk, Link Road Bilaspur C.G.
        </address>

        <span class="ct__edge" aria-hidden="true"></span>
      </li>

      <li class="ct__card">
        <span class="ct__ico ct__ico--violet" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
            <path d="M6.5 3.5h3l1.5 4-2 1.5a13 13 0 0 0 6 6l1.5-2 4 1.5v3a2 2 0 0 1-2.2 2A17 17 0 0 1 4.5 5.7a2 2 0 0 1 2-2.2z" />
          </svg>
        </span>

        <h3 class="ct__name">Phone Number</h3>
        <span class="ct__rule" aria-hidden="true"></span>

        <span class="ct__body ct__body--links">
          <a href="tel:9109911372">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" aria-hidden="true">
              <path d="M6.5 3.5h3l1.5 4-2 1.5a13 13 0 0 0 6 6l1.5-2 4 1.5v3a2 2 0 0 1-2.2 2A17 17 0 0 1 4.5 5.7a2 2 0 0 1 2-2.2z" />
            </svg>
            9109911372
          </a>
          <a href="tel:9201996377">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" aria-hidden="true">
              <path d="M6.5 3.5h3l1.5 4-2 1.5a13 13 0 0 0 6 6l1.5-2 4 1.5v3a2 2 0 0 1-2.2 2A17 17 0 0 1 4.5 5.7a2 2 0 0 1 2-2.2z" />
            </svg>
            9201996377
          </a>
          <a href="tel:07752-414580">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" aria-hidden="true">
              <path d="M6.5 3.5h3l1.5 4-2 1.5a13 13 0 0 0 6 6l1.5-2 4 1.5v3a2 2 0 0 1-2.2 2A17 17 0 0 1 4.5 5.7a2 2 0 0 1 2-2.2z" />
            </svg>
            07752-414580
          </a>
        </span>

        <span class="ct__edge" aria-hidden="true"></span>
      </li>

      <li class="ct__card">
        <span class="ct__ico ct__ico--blue" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
            <rect x="2.5" y="4.5" width="19" height="15" rx="2.5" />
            <path d="m3 7 9 6 9-6" />
          </svg>
        </span>

        <h3 class="ct__name">Email Us</h3>
        <span class="ct__rule" aria-hidden="true"></span>

        <span class="ct__body ct__body--links">
          <a href="mailto:info@resiliencesoft.com">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <rect x="2.5" y="4.5" width="19" height="15" rx="2.5" />
              <path d="m3 7 9 6 9-6" />
            </svg>
            info&#64;resiliencesoft.com
          </a>
        </span>

        <span class="ct__edge" aria-hidden="true"></span>
      </li>
    </ul>

    <!-- ============================================================
         CTA
         ============================================================ -->
    <div class="ct__cta">
      <button type="button" class="ct__btn" (click)="onConsult()">
        Schedule a Consultation
        <i aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14M13 6l6 6-6 6" />
          </svg>
        </i>
      </button>
    </div>
  </div>
</section>
